export default __webpack_public_path__ + "static/media/Intersemibold.41bfe4c8.woff";